import React from 'react';
import { useAuth0 } from '@auth0/auth0-react';
import { Navigate } from 'react-router-dom';
import { Box, CircularProgress } from '@mui/material';
import { useUserMsp } from '../hooks/useUserMsp';
import { isHorizonRootRole } from '../utils/horizonRoles';

interface ProtectedObserverRouteProps {
  children: React.ReactNode;
}

/** Route guard for observer-only pages; unauthorized users are redirected without disclosure. */
const ProtectedObserverRoute: React.FC<ProtectedObserverRouteProps> = ({ children }) => {
  const { isAuthenticated, isLoading: authLoading } = useAuth0();
  const { userMspInfo, isLoading: mspLoading, error: mspError } = useUserMsp();

  const isResolvingMspProfile =
    isAuthenticated && (mspLoading || (!mspError && !userMspInfo));

  if (authLoading || isResolvingMspProfile) {
    return (
      <Box display="flex" justifyContent="center" alignItems="center" minHeight="400px">
        <CircularProgress />
      </Box>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/" replace />;
  }

  if (mspError) {
    return <Navigate to="/msp-analytics" replace />;
  }

  if (!isHorizonRootRole(userMspInfo?.role)) {
    return <Navigate to="/msp-analytics" replace />;
  }

  return <>{children}</>;
};

export default ProtectedObserverRoute;
